import Config from '@config';

export type Flags = {
  featureLightDarkMode: boolean;
  featureFlagsSwitcher: boolean;
  featureHouseholdRedirect: boolean;
};

export const defaultFlags: Flags = {
  featureLightDarkMode: Config.VITE_FEATURE_LIGHT_DARK_MODE === 'true',
  featureFlagsSwitcher: Config.VITE_FEATURE_FLAG_SWITCHER === 'true',
  featureHouseholdRedirect: Config.VITE_FEATURE_HOUSEHOLD_REDIRECT === 'true',
};
